import { colorPalette } from '../../colorPalette';
export const transferSummaryHeaderStyles = () => ({
    container: {
        backgroundColor: 'transparent',
    },
    transferLogoImg: {
        margin: '0px',
    },
    clubR: {
        position: 'relative',
        width: '56px',
        height: '22px',
        backgroundColor: `${colorPalette.gray100} !important`,
        borderRadius: '5px',
        margin: 'auto 12px',
        boxSizing: 'content-box'
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        height: '65px',
        alignItems: 'center',
        boxSizing: 'border-box'
    },
    leftPaperContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
